import { geebeeRootBaseApiWithTags } from '@/services/base/geebeeRoute';
import { definitions } from '@/types/schema';
import {
  CspCollegeSuggestionRequestType,
  CspCollegeSuggestionResponseType,
  CspFocusedCollegeSuggestionRequestType,
  CspFocusedCollegeSuggestionResponseType,
  GetApplicationPreVisaResponse,
  GetOnHoldResolutionDriveEnabledRequestType,
  GetOnHoldResolutionDriveEnabledResponseType,
  GetSimilarCourseRequestType,
  GetSimilarCourseResponseType,
  UpdateApplicationPreVisaRequest,
  UpdateApplicationPreVisaResponse,
} from '@/types/Services';

import { transformResponse } from './utils';

export const applicationApi = geebeeRootBaseApiWithTags.injectEndpoints({
  endpoints: (builder) => ({
    //need to change this
    getApplicationPreVisa: builder.query<
      GetApplicationPreVisaResponse,
      { applicationId: number }
    >({
      query: ({ applicationId }) =>
        `/v1/applications/${applicationId}/pre-visa`,
      providesTags: [`preVisaStatus`],
      transformResponse: ({ success, data, message }) => {
        if (!success) {
          return {
            data: null,
            message,
            apiError: true,
          } as unknown as GetApplicationPreVisaResponse;
        } else {
          return { data } as unknown as GetApplicationPreVisaResponse;
        }
      },
    }),
    updateApplicationPreVisa: builder.mutation<
      UpdateApplicationPreVisaResponse,
      UpdateApplicationPreVisaRequest
    >({
      query: ({ applicationId, body }) => ({
        url: `/v1/applications/${applicationId}/pre-visa`,
        method: `POST`,
        body,
      }),
      invalidatesTags: [`preVisaStatus`],
      transformResponse: ({ success, data, message }) => {
        if (!success) {
          return {
            data: null,
            message,
            apiError: true,
          } as unknown as UpdateApplicationPreVisaResponse;
        } else {
          return { data } as unknown as UpdateApplicationPreVisaResponse;
        }
      },
    }),
    applicationsBulkUpdate: builder.mutation<
      definitions['ResponseWrapper«boolean»'],
      definitions['CreateApplicationsInBulkDtoCsp']
    >({
      query: (body) => ({
        url: `v1/applications/bulk`,
        method: `POST`,
        body,
      }),
      invalidatesTags: [`ShortlistRequest`],
    }),
    getUniversitySuggestions: builder.mutation<
      CspCollegeSuggestionResponseType,
      CspCollegeSuggestionRequestType
    >({
      query: (body) => ({
        url: `/cf/university`,
        method: `POST`,
        body,
      }),
      transformResponse: ({ success, data, message }) => {
        if (!success) {
          return {
            data: null,
            message,
            apiError: true,
          } as unknown as CspCollegeSuggestionResponseType;
        } else {
          return { data } as unknown as CspCollegeSuggestionResponseType;
        }
      },
    }),
    getFocusedUniversitySuggestions: builder.query<
      CspFocusedCollegeSuggestionResponseType,
      CspFocusedCollegeSuggestionRequestType
    >({
      query: ({ cspId }) => ({
        url: `/cf/focused-universities/${cspId}`,
      }),
      transformResponse,
    }),
    getUniversityVendorSuggestions: builder.mutation<
      CspCollegeSuggestionResponseType,
      CspCollegeSuggestionRequestType
    >({
      query: (body) => ({
        url: `/cf/university/vendor`,
        method: `POST`,
        body,
      }),
      transformResponse: ({ success, data, message }) => {
        if (!success) {
          return {
            data: null,
            message,
            apiError: true,
          } as unknown as CspCollegeSuggestionResponseType;
        } else {
          return { data } as unknown as CspCollegeSuggestionResponseType;
        }
      },
    }),
    createRemarkBasedTask: builder.mutation<
      definitions['ResponseWrapper«boolean»'],
      { remarkId: number }
    >({
      query: (body) => ({
        url: `remarks/${body.remarkId}/create-task`,
        method: `POST`,
      }),
    }),
    getSimilarCourses: builder.mutation<
      GetSimilarCourseResponseType,
      GetSimilarCourseRequestType
    >({
      query: (body) => ({
        url: `/cf/recommended/courses`,
        method: `POST`,
        body,
      }),
      transformResponse: ({ success, data, message }) => {
        if (!success) {
          return {
            data: null,
            message,
            apiError: true,
          } as unknown as GetSimilarCourseResponseType;
        } else {
          return { data } as unknown as GetSimilarCourseResponseType;
        }
      },
    }),
    updateOnHoldResolutionDriveEnabledEmail: builder.mutation<
      GetOnHoldResolutionDriveEnabledResponseType,
      GetOnHoldResolutionDriveEnabledRequestType
    >({
      query: (body) => ({
        url: `/v1/applications/${body.applicationId}/on-hold-resolution-drive/${body.email}`,
        method: `POST`,
      }),
    }),
  }),
});

export const {
  useGetApplicationPreVisaQuery,
  useUpdateApplicationPreVisaMutation,
  useGetUniversitySuggestionsMutation,
  useCreateRemarkBasedTaskMutation,
  useApplicationsBulkUpdateMutation,
  useGetSimilarCoursesMutation,
  useGetUniversityVendorSuggestionsMutation,
  useGetFocusedUniversitySuggestionsQuery,
  useUpdateOnHoldResolutionDriveEnabledEmailMutation,
} = applicationApi;
